module.exports = __webpack_public_path__ + "img/70.status_soap.7ba1ab90.svg";